import {
  MediaReplaceButton,
  MediaRemoveButton,
} from '@components/media-upload';
const {
  i18n: { __ },
  components: { Button },
  blockEditor: { MediaUpload, MediaUploadCheck },
} = wp;

const DownloadSettings = (props) => {
  const { attributes, setAttributes } = props;
  const { download } = attributes;

  return (
    <MediaUploadCheck>
      <MediaUpload
        onSelect={(file) => {
          setAttributes({
            download: {
              id: file.id,
              title: file.title,
              filename: file.filename,
              url: file.url,
              fileType: file.type,
            },
          });
        }}
        allowedTypes={[
          'image',
          'video',
          'audio',
          'application',
          'text',
          'multipart',
        ]}
        value={download.id}
        render={({ open }) => (
          <div className="media-upload image-upload">
            {download.id && (
              <>
                {['image', 'audio'].includes(download.fileType) ? (
                  <div className="e-cmp__media-preview">
                    <embed
                      key={download.id}
                      src={download.url}
                      alt={download.filename}
                    />
                  </div>
                ) : (
                  <div className="video-file-name">
                    <p>{download.filename}</p>
                  </div>
                )}
                <div className="upload-buttons-wrapper">
                  <MediaReplaceButton onClick={open} />
                  <MediaRemoveButton
                    onClick={() =>
                      setAttributes({
                        download: {},
                      })
                    }
                  />
                </div>
              </>
            )}
            {!download.id && (
              <Button onClick={open}>{__('Upload a file', 'b3rg')}</Button>
            )}
          </div>
        )}
      />
    </MediaUploadCheck>
  );
};

export default DownloadSettings;
